<div
  [class]="'small-button' + (primary ? ' primary' : '') + (danger ? ' danger' : '') + (iconOnly ? ' icon-only' : '') + (smallIconButton ? ' small-icon-button' : '') + (mediumIconButton ? ' medium-icon-button' : '') + (disabled ? ' disabled' : '')"
  [matMenuTriggerFor]="matMenuTriggerFor"
  [matMenuTriggerData]="matMenuTriggerData"
  (click)="!disabled && buttonClick.emit()">
  @if (avatarInitials) {
    <span
      class="small-button-avatar"
      [style.background]="avatarBackground">{{ avatarInitials }}</span>
  } @else if (image) {
    <tidy-image
      [src]="image"
      class="small-button-icon"
      [class.small-button-icon--color]="colorImage" />
  }
  @if (text && !iconOnly && !smallIconButton && !mediumIconButton) {
    <tidy-text
      [headerButton]="text"
      class="white" />
  }
</div>
